module.exports = __webpack_public_path__ + "img/gradient.f08e4083.png";